module.exports = __webpack_public_path__ + "img/image50.960298dd.png";